import { render, staticRenderFns } from "./MyWorkComponent.vue?vue&type=template&id=317cec67&scoped=true"
import script from "./MyWorkComponent.vue?vue&type=script&lang=js"
export * from "./MyWorkComponent.vue?vue&type=script&lang=js"
import style0 from "./MyWorkComponent.vue?vue&type=style&index=0&id=317cec67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317cec67",
  null
  
)

export default component.exports